// Build stamp injected by Vite `define` (see vite.config.ts). Format:
// "<git-short-hash> · YYYY-MM-DD HH:mm". Falls back to 'dev' when the bundle
// was not built through Vite (e.g. some test runners).
declare const __BUILD_ID__: string | undefined;

export const BUILD_ID: string =
  typeof __BUILD_ID__ !== 'undefined' && __BUILD_ID__ ? __BUILD_ID__ : 'dev';

/** Just the commit hash portion (before the separator), for compact display. */
export const BUILD_HASH: string = BUILD_ID.split(' · ')[0] || BUILD_ID;
